<template>
  <div class="population-topic" :class="className" v-inview="{ callback: onInview }">
    <h3 class="population-topic__title">人數很有影響力，但有沒有去投票才是關鍵！</h3>
    <div class="population-topic__summary">
      <p>年輕選民在人數上具有影響力，但實際投票行為遠低於平均值，上一屆總統大選有超過300萬年輕族群投票動向不明，藍綠都想把鍵盤戰士化為實際選票。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopulationTopic',
  data () {
    return {
      isInview: false
    }
  },
  computed: {
    className () {
      return {
        'population-topic--inview': this.isInview
      }
    }
  },
  methods: {
    onInview () {
      this.isInview = true
    }
  }
}
</script>

<style lang="scss">
.population-topic {
  $comp: &;
  opacity: 0;
  transform: translateY(10px);

  &__title {
    color: #21a088;
    font-size: 1.25em;
    font-weight: bold;
    text-align: left;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      text-align: center;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1.375em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      font-size: 1.875em;
    }
  }

  &__summary {
    margin-top: 8px;
    color: #1a1a1a;
    font-size: 0.875em;
    font-weight: 600;
    line-height: 1.714em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 25px;
      font-size: 1em;
      line-height: 1.5em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_DESKTOP) {
    }
  }

  &--inview {
    opacity: 1;
    transform: translateY(0);
    transition:
      opacity 0.4s ease 0.5s,
      transform 0.4s ease 0.5s;
  }
}
</style>
